// extracted by mini-css-extract-plugin
export default {"header":"SectionHeader_header__uLXc2","title":"SectionHeader_title__BtoK8","subtitle":"SectionHeader_subtitle__poUEY"};